import React from 'react';
import { Card, CardContent } from './ui/card';
import { Building2 } from 'lucide-react';
import { clients } from '../data/mock';

export const Clients = () => {
  return (
    <section id="clients" className="py-24 bg-gray-50">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Nos <span className="text-green-600">Références</span>
          </h2>
          <p className="text-lg text-gray-700">
            Ils nous font confiance pour leurs projets techniques et industriels
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {clients.map((client) => (
            <Card key={client.id} className="group hover:shadow-xl transition-all duration-300 bg-white border-gray-200">
              <CardContent className="p-6 flex flex-col items-center justify-center min-h-[140px]">
                <div className="bg-gradient-to-br from-green-50 to-orange-50 p-4 rounded-full mb-3 group-hover:scale-110 transition-transform">
                  <Building2 className="h-8 w-8 text-green-600" />
                </div>
                <div className="text-center font-semibold text-gray-900 group-hover:text-green-600 transition-colors">
                  {client.name}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-600 italic">
            Et de nombreux autres clients satisfaits dans le BTP, l'industrie et la logistique
          </p>
        </div>
      </div>
    </section>
  );
};